import styled from 'styled-components'
export const TableContainer = styled.div`
  padding-top: ${({ theme }) => theme.spacing.mini};
  width: 100%;
`

export const StyledTableContainer = styled.div`
  td,
  th {
    border-inline-end: 0px;
  }
`
